export default __webpack_public_path__ + "static/media/img6.bd9aecd2.png";